var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "22px",
    viewBox: "0 0 23 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2155A5C9-129A-4631-A231-1BA793895001") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1440-desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-1440--Infobox-landing-page-",
    transform: "translate(-172, -7231)",
    fill: "#F9F9F9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer",
    transform: "translate(0, 6891)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/youtube-copy-2",
    transform: "translate(172.5094, 340.44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.60438001,21.0284337 L12.3202321,21.0284337 L12.3202321,13.1056806 C12.3202321,12.6821835 12.351005,12.2575659 12.4755771,11.9550794 C12.8163596,11.1074849 13.5923241,10.230078 14.895469,10.230078 C16.6015024,10.230078 17.284388,11.5311021 17.284388,13.4386998 L17.284388,21.0284337 L22,21.0284337 L22,12.8930716 C22,8.53508922 19.6737072,6.50712116 16.5709697,6.50712116 C14.0271459,6.50712116 12.9099187,7.92891573 12.2892191,8.89728068 L12.3205922,8.89728068 L12.3205922,6.84022046 L7.60474016,6.84022046 C7.6662859,8.17129709 7.60438001,21.0289139 7.60438001,21.0289139 L7.60438001,21.0284337 Z M2.63702275,4.90285028 C4.28127035,4.90285028 5.30493843,3.81331466 5.30493843,2.45174528 C5.27416556,1.05912291 4.28127035,0 2.66827582,0 C1.05416083,0 0,1.05912291 0,2.45162523 C0,3.81319461 1.02326791,4.90273023 2.60608982,4.90273023 L2.63662259,4.90273023 L2.63702275,4.90285028 Z M4.99408844,21.0284337 L4.99408844,6.83974026 L0.277956236,6.83974026 L0.277956236,21.0284337 L4.99456864,21.0284337 L4.99408844,21.0284337 Z",
    id: "Fill-1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.40edbee5623f9d39c52e330d8f937ba2.svg";
export { ForwardRef as ReactComponent };